/**
 * Stack of open modal overlays (sheets, the nav drawer, confirm dialogs).
 * The edge-swipe gesture asks this first: with an overlay open, a swipe closes
 * the top one instead of navigating.
 */
const stack: Array<() => void> = [];

/** Registers an open overlay's close action; returns the unregister function. */
export function pushOverlay(close: () => void): () => void {
  stack.push(close);
  return () => {
    const i = stack.lastIndexOf(close);
    if (i >= 0) stack.splice(i, 1);
  };
}

export const hasOverlay = (): boolean => stack.length > 0;

/** Closes the top-most overlay. Returns false when none is open. */
export function closeTopOverlay(): boolean {
  const close = stack[stack.length - 1];
  if (!close) return false;
  close();
  return true;
}

/** Closes every open overlay, top first (a wall tablet going back to its home view). Returns how many. */
export function closeAllOverlays(): number {
  const all = [...stack].reverse();
  for (const close of all) close();
  return all.length;
}
